"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnHoverResult = void 0;
/**
 * @public
 */
class OnHoverResult {
    constructor(newlyHovered, stillHovered, noLongerHovered, unchanged) {
        this.newlyHovered = newlyHovered;
        this.stillHovered = stillHovered;
        this.noLongerHovered = noLongerHovered;
        this.unchanged = unchanged;
    }
}
exports.OnHoverResult = OnHoverResult;
//# sourceMappingURL=on-hover-result.js.map